/**
 * Physical Constants for Heat Pump Simulation
 */

// Room dimensions
export const ROOM_WIDTH = 550;
export const ROOM_HEIGHT = 350;
export const MAX_N_HORIZONTAL = 3;
export const MAX_N_VERTICAL = 4;

// Radiator constraints
export const MIN_RAD_N_1 = 4;
export const MAX_RAD_N_1 = 10;

// Water properties
export const CP_WATER = 4180; // J/(kg·K) - Specific heat capacity of water
export const D_WATER = 1000; // kg/m³ - Density of water

// Air properties
export const CP_AIR = 1005; // J/(kg·K) - Specific heat capacity of air
export const D_AIR = 1.2; // kg/m³ - Density of air

// System defaults
export const DEFAULT_COMPRESSOR_EFFICIENCY = 0.5;
export const DEFAULT_FRICTION_COEFFICIENT = 0.03;
export const ROOM_HEAT_CAPACITY = 2e4; // J/K
export const SIMULATION_UPDATE_INTERVAL = 200; // ms

// Radiator exponent for heat transfer
export const RADIATOR_EXPONENT = 1.3;

/**
 * Valve flow rate data (LPM at 100 mBar)
 * Key: position (1-7), Value: flow rate in liters per minute
 */
export const VALVE_FLOW_RATES = {
  1: 2.108,
  2: 4.743,
  3: 8.433,
  4: 12.649,
  5: 16.338,
  6: 19.501,
  7: 22.136,
};

/**
 * Radiator nominal power ratings (W)
 * Organized by length (mm) and type
 * At ΔT = 50K (75/65/20)
 */
export const RADIATOR_POWER_MATRIX = {
  400: { 10: 251, 11: 364, 20: 0, 21: 503, 22: 654, 30: 0, 33: 928 },
  500: { 10: 314, 11: 455, 20: 0, 21: 629, 22: 818, 30: 0, 33: 1160 },
  600: { 10: 376, 11: 545, 20: 0, 21: 754, 22: 981, 30: 0, 33: 1391 },
  700: { 10: 439, 11: 636, 20: 0, 21: 880, 22: 1145, 30: 0, 33: 1623 },
  800: { 10: 502, 11: 727, 20: 0, 21: 1006, 22: 1308, 30: 0, 33: 1855 },
  900: { 10: 564, 11: 818, 20: 0, 21: 1131, 22: 1472, 30: 0, 33: 2087 },
  1000: { 10: 627, 11: 909, 20: 0, 21: 1257, 22: 1635, 30: 0, 33: 2319 },
};

/**
 * City temperature data
 * Design outdoor temperatures for German cities
 */
export const CITY_TEMPERATURES = {
  aachen: { name: "Aachen", temperature: -7 },
  berlin: { name: "Berlin", temperature: -11 },
  hamburg: { name: "Hamburg", temperature: -9 },
  stuttgart: { name: "Stuttgart", temperature: -9 },
  hannover: { name: "Hannover", temperature: -10 },
};

/**
 * Color constants for visualization
 */
export const COLORS = {
  hotWater: "rgba(255, 0, 0, {alpha})",
  coldWater: "rgba(70, 130, 180, {alpha})",
  thermostat: "rgba(256, 165, 0, {alpha})",
  background: "transparent",
};
